import { useAtomValue } from 'jotai';

import { LiveAnalysisContent } from '@blocks';
import { isCurrentActivityAtom } from '@store';

export const LiveAnalysis = () => {
    const isCurrentActivity = useAtomValue(isCurrentActivityAtom);
    return <LiveAnalysisContent readOnly={!isCurrentActivity} />;
};
